import {map} from 'lodash'
const LOAD = 'server-sts/sessions/LOAD';
const LOAD_SUCCESS = 'server-sts/sessions/LOAD_SUCCESS';
const LOAD_FAIL = 'server-sts/sessions/LOAD_FAIL';


const initialState = {
  loaded: false,
  loading: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      }
    default:
      return state;
  }
}

export function isLoaded(globalState) {
  return globalState.sessions && globalState.sessions.loaded;
}



export function loadHistory() {
  return {
    promise: (session) => session.post('/history/load'),
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL]
  };
}

